import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { StockStatisticsItem } from "../types";
import { loadSecurityStatistics } from "../thunks/getSecurityStatisticsThunk";

export const useDisplaySecurityStatistics = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    StockStatisticsItem | undefined
  >((store) => store.data.reports.securityStatistics.displaySecurityStatistics);

  const displayedStatistics =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadSecurityStatistics( symbol));
    }
  }, [dispatch, symbol]);

  return displayedStatistics;
};